<!--
 * @Author: Merlin
 * @Date: 2024-03-25 19:09:00
 * @LastEditors: Merlin
 * @LastEditTime: 2024-08-12 14:12:24
 * @Description: 左侧横向伸缩的小面板  
-->

<template>
    <div class="side-bar relative">
        <div class="side-bar-head flex group items-center justify-center space-x-2"
            @click="bodyConfig.showSideBody = !bodyConfig.showSideBody"
        >
            <img src="../img/about.png" width="16" height="16" alt="" />
            <span class=" group-hover:text-white">
                {{ $t('GameBlackJack.SideBetInfo') }}
            </span>
        </div>
        <div class="side-bar-body translate-x-0 duration-500"
            :class="
                bodyConfig.showSideBody
                ? ' translate-x-0'
                : ' translate-x-[-100%]'
            "
        >
            <div class="side-bar-body-click"
                @click="bodyConfig.showSideBody = false"
            ></div>
            <img style="pointer-events: none"
                :src="sRulePic"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import rules_en from "../img/open.png";
import rules_cn from "../img/open-cn.webp";

const $i18n = useNuxtApp().$i18n;
const bodyConfig = reactive({
    showSideBody: false,
});


const sRulePic = computed(()=>{
    if ($i18n.locale.value == 'cn'){
        return rules_cn;
    }
    return rules_en;
});


// watch(
//     () => bodyConfig.showSideBody,
//     (value) => {
//         if (!value) {
//             currentBodyClass.value = bodyConfig.closeCalss;
//         } else {
//             currentBodyClass.value = bodyConfig.openClass;
//         }
//         setTimeout(() => {
//             currentBodyClass.value = '';
//         }, 3000);
//     },
//     { immediate: true },
// );
</script>

<style lang="scss" scoped src="../style/blackjack-wrapper.scss"></style>

